<template>
    <transition name="toast-slide">
      <div v-if="visible" :class="['toast-container', type]" @mouseenter="pauseTimeout" @mouseleave="resumeTimeout">
        <span class="toast-message" v-html="message"></span>
        <button class="close-button" @click="hideToast">×</button>
      </div>
    </transition>
  </template>
  
  <script>
  export default {
    name: 'GlobalToast',
    data() {
      return {
        visible: false,
        message: '',
        type: 'success',
        timeout: null,
        duration: 3000,
        startTime: 0,
        remaining: 0,
      }
    },
    methods: {
      show(message, type = 'success', duration = 3000) {
        this.message = message
        this.type = type
        this.duration = duration
        this.visible = true
        this.startTime = Date.now()
        this.remaining = duration
  
        this.clearToastTimeout()
        this.timeout = setTimeout(this.hideToast, this.duration)
      },
      hideToast() {
        this.visible = false
      },
      pauseTimeout() {
        clearTimeout(this.timeout)
        const elapsed = Date.now() - this.startTime
        this.remaining = this.remaining - elapsed
      },
      resumeTimeout() {
        this.startTime = Date.now()
        this.timeout = setTimeout(this.hideToast, this.remaining)
      },
      clearToastTimeout() {
        clearTimeout(this.timeout)
        this.timeout = null
      }
    }
  }
  </script>
  
  <style scoped>
  .toast-container {
    position: fixed;
    top: 30px;
    left: 50%;
    transform: translateX(-50%);
    background-color: white;
    color: black;
    padding: 14px 26px;
    border-radius: 6px;
    font-size: 18px;
    font-weight: 500;
    box-shadow: 0 6px 12px rgba(0, 0, 0, 0.15);
    min-width: 400px;
    max-width: 640px;
    text-align: center;
    z-index: 9999;
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;
  }
  
  /* Progress bar effect */
  .toast-container::after {
    content: "";
    position: absolute;
    bottom: 0;
    left: 0;
    height: 6px;
    background-color: currentColor;
    width: 100%;
    transform: scaleX(0);
    transform-origin: left;
    animation: progressBarAnim 3s linear forwards;
    pointer-events: none;
  }
  
  /* Pause animasi saat hover */
  .toast-container:hover::after {
    animation-play-state: paused;
  }
  
  /* Warna status */
  .toast-container.success {
    color: #4CAF50;
  }
  .toast-container.error {
    color: #f44336;
  }
  .toast-container.warning {
    color: #ff9800;
  }
  
  @keyframes progressBarAnim {
    from {
      transform: scaleX(0);
    }
    to {
      transform: scaleX(1);
    }
  }
  
  /* Tombol close */
  .close-button {
    position: absolute;
    top: 8px;
    right: 14px;
    background: transparent;
    border: none;
    font-size: 22px;
    color: #555;
    cursor: pointer;
  }
  .close-button:hover {
    color: #000;
  }
  
  /* Animasi slide dari tengah */
  .toast-slide-enter-active,
  .toast-slide-leave-active {
    transition: all 0.4s ease;
  }
  .toast-slide-enter {
    opacity: 0;
    transform: translate(-50%, -40px);
  }
  .toast-slide-enter-to {
    opacity: 1;
    transform: translate(-50%, 0);
  }
  .toast-slide-leave {
    opacity: 1;
    transform: translate(-50%, 0);
  }
  .toast-slide-leave-to {
    opacity: 0;
    transform: translate(-50%, -40px);
  }
  </style>


// WEBPACK FOOTER //
// src/components/GlobalToast.vue